import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./banner.css";
import htmlParser from "html-react-parser";



export default function Banner({ bannerData }) {
  const [navbar, setNavbar] = useState(false);
  const imgCDNURL = process.env.REACT_APP_CDN_URL;
  return (
    <>
      <div className="banner">
        <Container className="banner-container">
          <Row className="banner-row">
            <Col sm={12} lg={8} xl={8}>
              <p className="bannerarttext">{bannerData.eventName}</p>
              <div className="">
               
                <p className="bannerpara">{bannerData.bannerPara}</p>
              </div>
              <p className="successhome">{bannerData.bannerdes}</p>
              <div className="listoflist">
                <p className="meetgrit">{bannerData.meetgrit}</p>
                <div className="meetgritdiv">
                <ul className="gain-points">
                  {bannerData.whatYouWillGain.points.map((point, index) => (
                    <li key={index} className="gain-point">
                     {point.heading}
                      {/* <p>{point.description}</p> */}
                    </li>
                  ))}
                </ul>
                </div>
              
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
